import React, {useCallback, useEffect, useState} from "react";
import {DOCUSIGN_SUCCESS} from "../../constants/apiConstant";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {FaCheckCircle} from "react-icons/fa"; // React icon
import {Button} from "@mui/material";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../constants/helper";
import {Grid} from "@mui/system";
import style from "../../assets/css/checkout.module.scss";
import {TbPencilCheck} from "react-icons/tb";
import Esign from "../../assets/img/icons/e-signdone.png";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";

const Success = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {docusignData} = useSelector(selectDataStoreState);
  const [countdown, setCountdown] = useState(15);

  const clearAndClose = () => {
    dispatch(setUiData({showLoader: false, eSignModal: null}));
    dispatch(setDataStore({docusignData: null, docusignURL: null}));

    // Attempt to close window if opened via script
    if (window.opener) {
      window.close();
    } else {
      GlobalNotificationPopup({
        type: "success",
        message: "Sign Completed, Please Close the window.",
      });
      window.close();
    }
  };

  const docusignSuccess = useCallback(async () => {
    if (!docusignData?.proposal_id) {
      console.error("Proposal Number is missing");
      return;
    }

    dispatch(setUiData({showLoader: true}));

    try {
      const response = await fetch(DOCUSIGN_SUCCESS.url, {
        method: DOCUSIGN_SUCCESS.method,
        headers: {...DOCUSIGN_SUCCESS.headers, Accept: "application/json"},
        body: JSON.stringify({proposal_id: docusignData.proposal_id}),
      });

      const res = await response.json();

      if (res.status == 1) {
        clearAndClose();
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: res?.message || "An error occurred",
        });
        clearAndClose();
      }
    } catch (error) {
      console.error("Fetch error:", error);
      GlobalNotificationPopup({
        type: "error",
        message: error.message || "Something went wrong",
      });
      clearAndClose();
    }
  }, [docusignData, dispatch, navigate]);

  useEffect(() => {
    console.log("docusign:", docusignData);

    if (docusignData) {
      // const timeout = setTimeout(() => {
      docusignSuccess();
      // }, 3000);

      // return () => clearTimeout(timeout);
    }
  }, [docusignData, docusignSuccess]);

  // useEffect(() => {
  //   if (countdown === 0) {
  //     navigate('/dashboard');
  //   }

  //   const timer = setInterval(() => {
  //     setCountdown((prev) => prev - 1);
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, [countdown, navigate]);

  return (
    <>
      <section
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center"}}>
            <div className={style.paymentDoneMain}>
              <img src={Esign} alt="E-Sign Successful" />
              <h2>E-Sign Successful!</h2>
              {/* <p> Congratulations! 🎉 You've got covered.</p> */}
              {/* <p className="text-gray-600 mb-6">Redirecting to Dashboard in <span className="font-semibold">{countdown}</span> seconds...</p> */}

              {/* <Button
                variant="contained"
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                Back to Dashboard
              </Button> */}
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default Success;
